// Studyo Today Backend
// Package studyo.today.schedules.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/schedules/v1/resources/special_day_occurrence.proto (package studyo.today.schedules.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_type_date } from "@buf/googleapis_googleapis.bufbuild_es/google/type/date_pb.js";
import { file_google_type_dayofweek } from "@buf/googleapis_googleapis.bufbuild_es/google/type/dayofweek_pb.js";

/**
 * Describes the file studyo/today/schedules/v1/resources/special_day_occurrence.proto.
 */
export const file_studyo_today_schedules_v1_resources_special_day_occurrence = /*@__PURE__*/
  fileDesc("CkBzdHVkeW8vdG9kYXkvc2NoZWR1bGVzL3YxL3Jlc291cmNlcy9zcGVjaWFsX2RheV9vY2N1cnJlbmNlLnByb3RvEiNzdHVkeW8udG9kYXkuc2NoZWR1bGVzLnYxLnJlc291cmNlcyLFAQoUU3BlY2lhbERheU9jY3VycmVuY2USFgoOc3BlY2lhbF9kYXlfaWQYASABKAkSEwoJY3ljbGVfZGF5GAIgASgFSAASLQoLZGF5X29mX3dlZWsYAyABKA4yFi5nb29nbGUudHlwZS5EYXlPZldlZWtIABIgCgNkYXkYBCABKAsyES5nb29nbGUudHlwZS5EYXRlSAASEAoIcmV2aXNpb24YBSABKAUSFQoNc2hvdWxkX2RlbGV0ZRgGIAEoCEIGCgR3aGVuQiuqAihTdHVkeW8uVG9kYXkuU2NoZWR1bGVzLkdycGMuVjEuUmVzb3VyY2VzYgZwcm90bzM", [file_google_type_date, file_google_type_dayofweek]);

/**
 * Describes the message studyo.today.schedules.v1.resources.SpecialDayOccurrence.
 * Use `create(SpecialDayOccurrenceSchema)` to create a new message.
 */
export const SpecialDayOccurrenceSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schedules_v1_resources_special_day_occurrence, 0);

